import { useEffectOnce } from '@hooks';
import {
  Form, Input, Row, Col,
} from 'antd';
import { isPossiblePhoneNumber, AsYouType } from 'libphonenumber-js';
import PhoneInput from 'react-phone-input-2';
import request from '@api';

import 'react-phone-input-2/lib/style.css';

export default function AccountContact() {
  const form = Form.useFormInstance();

  useEffectOnce(() => {
    request('get-store-prefilled-value').then((res) => {
      const { code, data: userInfo } = res || {};
      if (code === 0) {
        const { primaryContactName, primaryPhoneNumber } = userInfo || {};
        const formData = form.getFieldsValue(true);
        form.setFieldsValue({
          primaryContactPhoneNum: formData.primaryContactPhoneNum || primaryPhoneNumber,
          primaryContactName: formData.primaryContactName || primaryContactName,
        });
      }
    }).catch(console.log);
  }, []);

  return (
    <Row gutter={20}>
      <Col span={8}>
        <Form.Item label="Primary contact name" name="primaryContactName">
          <Input />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Primary contact phone number"
          name="primaryContactPhoneNum"
          rules={[{

            validator: async (_, value) => {
              const val = new AsYouType().input(`+${value}`);
              if (value && !isPossiblePhoneNumber(val)) {
                return Promise.reject(new Error('Invalid phone number'));
              }
              return Promise.resolve();
            },
          }]}
        >
          <PhoneInput
            autoFormat={false}
            country="us"
            value="value"
            specialLabel="primaryPhoneNumber"
            inputProps={{ id: 'primaryPhoneNumber' }}
            id="phoneNumber"
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item
          label="Primary email"
          name="primaryEmail"
          rules={[
            { type: 'email', message: 'Invalid email' },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
    </Row>
  );
}
